import {
  READ_ACTION,
  CONTRACT_ADMINISTRATION,
  CREATE_CONTRACT_RESOURCE_MENU,
  MY_CONTRACT_RESOURCE_MENU,
  COTACOES_MENU,
  FINANCIAL_SOLUTION_RESOURCE_MENU,
  PARTNER_COMPANY_RESOURCE_MENU,
  PRODUCT_RESOURCE_MENU,
  CONTRACT_CLOSING_RESOURCE_MENU,
  CONTRACT_CLOSING_EXCEPTION_RESOURCE_MENU
} from "@/constants/resources";

export default [
  {
    title: "Contratos",
    icon: "none",
    children: [
      {
        title: "Novo contrato",
        route: "contract-save",
        icon: "PlusCircleIcon",
        resource: CREATE_CONTRACT_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Meus contratos",
        route: "contracts-list",
        icon: "FileTextIcon",
        resource: MY_CONTRACT_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "ADM contratos",
        route: "contract-administration",
        icon: "ClipboardIcon",
        resource: CONTRACT_ADMINISTRATION,
        action: READ_ACTION,
      },
      {
        title: "Competências",
        route: "contract-competences-list",
        icon: "CalendarIcon",
        resource: CONTRACT_CLOSING_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Alterações extraordinárias",
        route: "contract-closing-exceptions-report",
        icon: "AlertOctagonIcon",
        resource: CONTRACT_CLOSING_EXCEPTION_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Cotações",
        href: "https://docs.google.com/spreadsheets/d/1BTHWwRJgEH6noB7nGLI06iQTIfN801kRv2n_3N__jfo/edit?usp=sharing",
        icon: "TrelloIcon",
        resource: COTACOES_MENU,
        action: READ_ACTION,
      },
      {
        title: "Soluções financeiras",
        route: "financial-solutions-list",
        icon: "CheckCircleIcon",
        resource: FINANCIAL_SOLUTION_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Empresas",
        route: "companies-list",
        icon: "HomeIcon",
        resource: PARTNER_COMPANY_RESOURCE_MENU,
        action: READ_ACTION,
      },
      {
        title: "Produtos",
        route: "products-list",
        icon: "BoxIcon",
        resource: PRODUCT_RESOURCE_MENU,
        action: READ_ACTION,
      },
    ],
  },
];
